var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-custom"},[_c('Breadscrumbs',{attrs:{"links":[
      {
        name: 'Investor Relations',
        to: {
          path: '/investor-relations',
          query: {
            section: _vm.$route.query.section,
          },
        },
      } ]}}),_c('div',{staticClass:"page-actions"},[_c('h2',[_vm._v("Investor Relations")]),_c('v-spacer'),_c('button',{staticClass:"btn",on:{"click":_vm.editHandler}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("edit")]),_c('span',{staticClass:"mr-2"},[_vm._v("編輯")])],1)],1),_c('div',{staticClass:"block",staticStyle:{"margin-bottom":"30px"}},[_c('PageMenu',{attrs:{"sections":_vm.sections}},[_c(_vm.sectionView,{tag:"component",attrs:{"ir":_vm.ir}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }